import axios from '../plugins/axios'
// const URL = 'http://localhost:5000';

export default class getPusingan {
  /**
  * bahagian pusingan
  */

   async musim() {
    try {
      const result = await axios.get(`${process.env.VUE_APP_API_URL}/pusingan/musim`)
      return result.data.musim
    } catch (error) {
      console.log(error)
      alert(error)
    }
  }

  async paparpusingan() {
    try {
      const res = await axios.get(`${process.env.VUE_APP_API_URL}/pusingan`)
      return res;
    } catch (error) {
      alert(error)
    }
  }

  async getPusinganDataAll() {
    var tahun = "2022";
    return  [
      {"id":"01","pusingan":"01","bulan":"01","tahun":tahun},
      {"id":"02","pusingan":"02","bulan":"02","tahun":tahun},
      {"id":"03","pusingan":"03","bulan":"03","tahun":tahun},
      {"id":"04","pusingan":"04","bulan":"04","tahun":tahun},
      {"id":"05","pusingan":"05","bulan":"05","tahun":tahun},
      {"id":"06","pusingan":"06","bulan":"06","tahun":tahun},
      {"id":"07","pusingan":"07","bulan":"07","tahun":tahun},
      {"id":"08","pusingan":"08","bulan":"08","tahun":tahun},
      {"id":"09","pusingan":"09","bulan":"09","tahun":tahun},
      {"id":"10","pusingan":"10","bulan":"10","tahun":tahun},
      {"id":"11","pusingan":"11","bulan":"11","tahun":tahun},
      {"id":"12","pusingan":"12","bulan":"12","tahun":tahun},
      {"id":"13","pusingan":"ALL","bulan":"ALL","tahun":tahun},

    ]
  }

  async getSample() {
    var tahun = "2022";
    return  [
      {"id":"1","sample":"1","tahun":tahun},
      {"id":"2","sample":"2","tahun":tahun},
      {"id":"3","sample":"ALL","tahun":tahun},

    ]
  }

  async getSemuaPusingan(id) {
    try {
      const res = await axios.post(`${process.env.VUE_APP_API_URL}/pusingan/paparsemuapusingan`,
      {
        id:id
      })
      return res;
    } catch (err) {
      alert(err)
    }
  }

  async getMusim() {
    try {
      const res = await axios.get(`${process.env.VUE_APP_API_URL}/pusingan/musimhies`)
      return res;
    } catch (err) {
      alert(err)
    }
  }


  //////////////fais///////////////
  async getPusinganData() {
    try {
      const res = await axios.get(`${process.env.VUE_APP_API_URL}/pusingan/getPusinganAktif`)
      return res;
    } catch (error) {
      alert(error)
    }
  }

  async getAllPusingan() {
    try {
      const res = await axios.get(`${process.env.VUE_APP_API_URL}/pusingan/getAllPusingan`)
      return res;
    } catch (error) {
      alert(error)
    }
  }

}